<template>
	<div class="m-1">
		<b-modal ref="publish-modal" size="mg" id="modal-center" centered hide-footer title="还款申请">
			<div>
				<b-form>
					<b-form-group id="fieldset-horizontal" label-cols-sm="4" label-cols-lg="3" content-cols-sm
						content-cols-lg="8" class="" label="姓名:" label-for="input-horizontal">
						<b-form-input id="input-1" v-model="form.userName" type="email" placeholder="" disabled>
						</b-form-input>
					</b-form-group>
					<b-form-group id="fieldset-horizontal" label-cols-sm="4" label-cols-lg="3" content-cols-sm
						content-cols-lg="8" label="证件号码:" label-for="input-horizontal">
						<b-form-input id="input-2" v-model="form.userIdNoMask" placeholder="" disabled></b-form-input>
					</b-form-group>
					
					<div class="d-flex justify-content-start mr-3 pb-2 border-bottom ">
						支付方式：<strong v-if="payType=='wechatPay'" class="ml-5">微信支付</strong>
								<strong v-if="payType=='aliPay'" class="ml-5">支付宝</strong>
								<strong v-if="payType=='easyPay'" class="ml-5">首信易</strong>
					</div>
					
					<div class="d-flex  justify-content-around mr-3 mt-1 pb-2">
						
							
						<div class="border rounded-lg p-2  " role="button" @click="setPayMode('wechatPay')"
							:class="payType=='wechatPay'?'border-danger':''">
							<img src="../assets/wechatpay.svg"  style="width: 40px;"  />
						</div>
						<!-- <div class="border rounded-lg p-2" role="button" @click="setPayMode('aliPay')"
							:class="payType=='aliPay'?'border-danger':''">
							<img src="../assets/alipay.svg" style="width: 40px;"/>
						</div> -->
						<span class="text-primary"
							style="width: 2rem;font-size:90%; 
								position: relative;right:-50%;top:10px;">
								<a href="#" style="text-decoration: underline;" @click="showTip()">满减活动</a>
							</span>
						<div v-if="callEasyPay!=null">
							
							<div class="border rounded-lg p-2 " role="button" @click="setPayMode('easyPay')"
								:class="payType=='easyPay'?'border-danger':''">
								<div class="text-center text-wrap " style="width: 3rem;" >银行卡支付</div>
							
							
							</div>

						</div>
						
					</div>
					
					
					<div>
						<div v-for="(item, index) in LoanList" :key="index" class="border-top pt-3">
							<b-form-group id="fieldset-horizontal" label-cols-sm="3" label-cols-lg="3" content-cols-sm
								content-cols-lg="8" label="合同号:" label-for="input-horizontal">
								<b-form-input id="input-loanno" :value="item.loanContractNo" placeholder="" disabled>
								</b-form-input>
							</b-form-group>
							<b-form-group id="fieldset-horizontal" label-cols-sm="3" label-cols-lg="3" content-cols-sm
								content-cols-lg="8" label="应还金额:" label-for="input-horizontal">
								<b-form-input id="input-torepay" :value="item.totalRepyaAmount/100" placeholder="" disabled>
								</b-form-input>
							</b-form-group>

							<b-form-group id="fieldset-horizontal" label-cols-sm="3" label-cols-lg="3" content-cols-sm
								content-cols-lg="8" label="还款金额:" label-for="input-horizontal">
								<b-form-input id="input-repay" placeholder="输入还款金额" type="number" min="0.01"
									max="100000.00" v-model="repayInput[index]" required>
								</b-form-input>
								<div @click="copyInput(item.totalRepyaAmount/100,index)" class="text-primary" role="button" 
									style="position: absolute;top:10%;right:10%; text-decoration: underline;">填入应还金额</div>
							</b-form-group>
						</div>
					</div>
				</b-form>

				<div class="d-flex justify-content-end mr-3 mt-1 pt-3 border-top">
					<b-button variant="secondary" class="ml-3" @click="hideModal"> 取消</b-button>
					<b-button variant="success" class="ml-3" @click="confirmPay">确认支付 </b-button>
				</div>
			</div>
			<SxyRepayModal ref="sxyRepayModal"></SxyRepayModal>
			<ReductModal ref="reductModal"></ReductModal>
			<WaitingModal ref="waitingModal"></WaitingModal>
			<TipModal 	ref="tipModal"></TipModal>
		</b-modal>
	</div>
</template>
<script>
	import ReductModal from './ReductModal.vue';
	import WaitingModal from './WaitingModal.vue';
	import SxyRepayModal from './SxyRepayModal.vue';
	import TipModal from './TipModal.vue';
	export default {
		components: {
			ReductModal,
			WaitingModal,
			SxyRepayModal,
			TipModal
		},
		data() {
			return {
				form: {
					cardNo: '',
					bankName: '',
					userName: '',
					amount: 100,
					userIdNo: "",
					userIdNoMask: "",
					linkId: "",
					phone: "",
					smscode: "",
					totalAmount: 0,
				},
				maxSecond: 180,
				hasCards: 0,
				smsTimer: 0,
				cardList: [],
				crfUid: "",
				cardIndex: 0,
				loanNo: "",
				LoanList: null,
				repayInput: [],
				requestNo: "",
				showWaiting: false,
				waitTimer: 0,
				timeOut: 0,
				reductAmt: 0,
				repayInfo: null,
				openid: "",
				netRepay: 0,
				totalRepay: 0,
				payType:"wechatPay",
				fundSource:"",
				channelNo:"",
				callEasyPay:null,
			}
		},

		methods: {
			
			showTip(){
				this.$refs['tipModal'].showModal()
			},
			
			setPayMode(_payType){
				this.payType=_payType
				if(this.payType=="easyPay"){
					this.callEasyPay()
					this.hideModal()
				}
			},
			
			copyInput(_val,_index){
				this.repayInput[_index]=_val;
				this.$forceUpdate()
			},
			
			reduct(repayInfo, _openid, netRepay, reductAmt, totalRepay) {
				this.$refs['reductModal'].showModal(repayInfo, _openid, netRepay, reductAmt, totalRepay,this.payType,null)
			},
			
			formatCurrency(value) {
				if (!value) return '0.00';
				return new Intl.NumberFormat('zh-CN', { style: 'currency', currency: 'CNY' }).format(value);
			},
			
			showModal(userIdNo, userName, crfUid, totalAmount, loanList, reductAmt,fundSource,channelNo,_callEasyPay) {
				this.form.userIdNo = userIdNo;
				this.form.userName = userName;
				const start = userIdNo.slice(0, 4);
				const end = userIdNo.slice(-4);
				const maskedPart = '*'.repeat(userIdNo.length - 8);
				this.form.userIdNoMask = start + maskedPart + end;
				this.reductAmt = reductAmt;
				this.crfUid = crfUid;
				this.form.totalAmount = totalAmount;
				this.LoanList = loanList;
				this.repayInput = [];
				this.ts = 180;
				this.form.phone = ""
				this.form.smscode = ""
				this.waitTimer = 0;
				this.showWaiting = false;
				this.payType="wechatPay";
				this.channelNo=channelNo;
				this.fundSource=fundSource
				this.callEasyPay=_callEasyPay;
				this.$refs['publish-modal'].show()
			},
	

			hideModal() {
				this.$refs['publish-modal'].hide()
			},

			toast(toaster, append = false) {
				this.$bvToast.toast(toaster, {
					title: `提示`,
					toaster: "b-toaster-top-center",
					solid: true,
					variant: "danger",
					appendToast: append
				})
			},

			callBack() {
				this.reduct(this.repayInfo, this.openid, this.netRepay, this.reductAmt, this.totalRepay)
			},


			queryLast() {
				let that = this;
				this.$axios.get(that.$DOMAIN() + "/wechatApi/wechat/unified/repay/finalAmt/" + that.crfUid)
					.then(function(response) {
						console.log("openId=====>", response.data)
					})
					.catch(function(error) {
						console.log(error)
					});
			},

			goPay() {
				let that = this;
				const unixTimestamp = Math.floor(Date.now() / 1000);
				let _lastime = localStorage.getItem("_lastime")
				if (_lastime != null) {
					let tn = unixTimestamp - _lastime
					if (tn < that.maxSecond) {
						that.$refs['waitingModal'].showModal(that.maxSecond-tn, this.callBack)
						return
					}
				}
				this.callBack()
			},

			confirmPay() {
				this.totalRepay = 0;
				this.netRepay = 0;
				let that = this;
				for (var t = 0; t < this.LoanList.length; t++) {
					console.log("==============>",this.repayInput[t] * 1)
					if (this.repayInput[t] * 1 > this.LoanList[t].totalRepyaAmount / 100) {
						this.toast(this.LoanList[t].loanContractNo + " 还款金额不能大于应还金额")
						return
					}
					if (!isNaN(this.repayInput[t])) {
						this.totalRepay = this.totalRepay + this.repayInput[t] * 100
					}
				}
				
				if (this.totalRepay < 1000 || this.totalRepay > 5000000) {
					this.toast("总的还款金额要介于10.00到50000.00元之间")
					return
				}
				
				//this.netRepay = this.totalRepay - this.reductAmt
				//this.netRepay=Math.round(this.netRepay)
				let productType = ""
				this.openid = localStorage.getItem("_openid")
				let loanList = [];
				let isReduct = false
				for (var tt = 0; tt < this.LoanList.length; tt++) {
					if (!isNaN(this.repayInput[tt] * 1)) {

						let repayAmt = this.repayInput[tt] * 100;
						//如果还没减免
						if (!isReduct) {
							if(repayAmt>this.reductAmt){
								repayAmt = repayAmt - this.reductAmt
								isReduct = true;
							}
						}
						
						repayAmt=Math.round(repayAmt)
						this.netRepay=this.netRepay+repayAmt;
						
						if (this.LoanList[tt].productNo == 'LIFE0001') {
							loanList.push({
								"contractNo": this.LoanList[tt].loanContractNo,
								"repayAmt": repayAmt,
								"product": "shd"
							})
						} else {
							loanList.push({
								"contractNo": this.LoanList[tt].loanContractNo,
								"repayAmt": repayAmt,
								"product": "xfd"
							})
						}
					}
				}
				let shdCount = 0;
				let xfdCount = 0;
				//生活贷笔数
				for (var i = 0; i < that.LoanList.length; i++) {
					if (!isNaN(this.repayInput[i] * 1)) {
						if (that.LoanList[i].productNo === 'LIFE0001') {
							shdCount = shdCount + 1
						}
					}
				}
				//消费贷笔数
				for (var j = 0; j < that.LoanList.length; j++) {
					if (!isNaN(this.repayInput[j] * 1)) {
						if (that.LoanList[j].productNo != 'LIFE0001') {
							xfdCount = xfdCount + 1
						}
					}
				}
				if (xfdCount > 0 && shdCount > 0) {
					productType = "xfd,shd"
				} else {
					if (xfdCount > 0) {
						productType = "xfd"
					}
					if (shdCount > 0) {
						productType = "shd"
					}
				}
				let _repayInfo = {
					"repayInfo": loanList,
					"crfUid": that.crfUid,
					"linkId": that.form.linkId,
					"productType": productType,
					"amount": that.netRepay,
					"smsCode": that.form.smscode,
					"channelNo": that.channelNo,
					"reductAmt": that.reductAmt,
					"payPlat":that.payType,
					"fundSource":that.fundSource,
				};
				that.repayInfo = _repayInfo;
				that.$axios.get(that.$DOMAIN() + "/wechatApi/wechat/unified/repay/finalAmt/" + that.crfUid, {
						headers: {
							'openId': this.openid
						}
					})
					.then(function(response) {
						if (response.data.status == 1) {
							const h = that.$createElement
							const messageVNode = h('div', {
								class: ['foobar']
							}, [
								h('p', {
									class: ['text-center']
								}, [
									"您曾在" + response.data.payTime + "发起支付" ,
									h('strong', that.formatCurrency((response.data.payAmt + response.data.reductAmt) / 100 )),
									' 元，实际支付',
									h('strong', that.formatCurrency((response.data.payAmt / 100))),
									' 元，是否继续支付？'
								]),
							])
							that.$bvModal.msgBoxConfirm(messageVNode, {
									title: '支付确认',
									size: 'md',
									buttonSize: 'md',
									okVariant: 'success',
									okTitle: '确认',
									cancelTitle: '取消',
									footerClass: 'p-2',
									hideHeaderClose: false,
									centered: true
								})
								.then(value => {
									if (value) {
										that.goPay()
									}
								})
								.catch(err => {
									console.log(err)
								})
						} else {
							that.goPay()
						}
					})
					.catch(function(error) {
						console.log(error)
					});
			},
		}

	}
</script>

<style>

</style>
